module.exports = __webpack_public_path__ + "static/media/notification.638496d7.mp3";